var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-date-picker',{ref:"date-picker-ref",attrs:{"weekday-format":_vm.getDay,"full-width":"","first-day-of-week":"-1","show-adjacent-months":"","allowed-dates":_vm.getAllowedDates,"color":"primary"},on:{"input":_vm.updateDate},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }